<template>
  <dl>
    <dt>申送事項(継続)</dt>
    <dd v-text="transferInformation"></dd>
    <dt class="comment">申送事項(単発)</dt>
    <dd class="comment" v-text="comment"></dd>
  </dl>
</template>

<script>
  export default {
    name: 'Information',
    data() {
      return {
        transferInformation: this.$store.getters.transferInformation,
        comment: this.$store.getters.comment,
      };
    },
  };
</script>

<style lang="scss" scoped>
  dl {
    margin-bottom: 0;

    dt, dd {
      margin-bottom: 0;

      &.comment {
        color: #ff0000;
      }
    }

    dd {
      white-space: pre-wrap;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/parts/Information.vue?f81d6d50